import { memo } from 'react';

import { Descriptions } from 'antd';

function AppList({ bordered = false, children, colon = false, column = 1, size = 'small' }) {
  return (
    <Descriptions
      bordered={bordered}
      size={size}
      column={column}
      colon={colon}
      styles={{ label: { color: 'rgba(0, 0, 0, 0.88)', fontWeight: 600, width: '15%' } }}>
      {children}
    </Descriptions>
  );
}

export default memo(AppList);
